// Запросы зоны pages к серверу (Лента, Библиотеки, Кабинет, разделы §10).
// api.ts принадлежит интегратору, поэтому свой маленький клиент: тот же
// заголовок токена, тот же ApiError, свой таймаут (long-poll Ленты — 30 с).

import { ApiError, getToken, setToken } from '../../api'

export { ApiError }

export async function http<T>(path: string, init: RequestInit = {}, timeoutMs = 15_000): Promise<T> {
  const headers = new Headers(init.headers)
  const token = getToken()
  if (token) headers.set('X-Agentbox-Token', token)
  if (init.body && typeof init.body === 'string') headers.set('Content-Type', 'application/json')
  const abort = new AbortController()
  const timer = window.setTimeout(() => abort.abort(), timeoutMs)
  let res: Response
  try {
    res = await fetch(`/api${path}`, { ...init, headers, credentials: 'same-origin', signal: abort.signal })
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') throw new ApiError(408, 'Сервер не ответил вовремя')
    throw error
  } finally {
    window.clearTimeout(timer)
  }
  if (res.status === 401) {
    setToken(null)
    throw new ApiError(401, 'Сессия оператора истекла')
  }
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new ApiError(res.status, errorText(text) || `Ошибка ${res.status}`)
  }
  if (res.status === 204) return undefined as T
  return res.json() as Promise<T>
}

/** `{"detail": "…"}` → «…»; список pydantic-ошибок → первые сообщения. */
export function errorText(raw: string): string {
  try {
    const data = JSON.parse(raw) as { detail?: unknown }
    if (typeof data.detail === 'string') return data.detail
    if (Array.isArray(data.detail)) {
      return data.detail
        .slice(0, 3)
        .map((d: { msg?: string; loc?: unknown[] }) => `${(d.loc ?? []).slice(1).join('.')}: ${d.msg ?? ''}`)
        .join('; ')
    }
  } catch {
    // не JSON — как есть
  }
  return raw
}

export function describe(error: unknown): string {
  if (error instanceof ApiError) return error.message
  if (error instanceof Error) return error.message
  return String(error)
}

/** Полный МСК-день для шапки Ленты: «среда, 23 сентября». */
export function mskDate(now: Date = new Date()): string {
  return now.toLocaleDateString('ru-RU', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Europe/Moscow' })
}

export function mskHm(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow' })
}
